import SimplifiedSettings from "./SimplifiedSettings";
export default SimplifiedSettings;